import { InsightsFilters, InsightsDateRange, InsightsStatusFilter } from '../../models/insights-dashboard.model';

export interface FilterOption<T = string | number> {
  value: T;
  label: string;
}

// Values/labels match the AskAyenDashboardGraphsAPIView `status` param contract exactly.
// Omitting the param (value: null) is the API default (open, answered + unanswered) —
// passing "open" literally is invalid and returns 400.
export const STATUS_OPTIONS: FilterOption<InsightsStatusFilter | null>[] = [
  { value: null, label: 'الأسئلة المفتوحة (الافتراضي)' },
  { value: 'open_not_answered', label: 'مفتوحة - لم تتم الإجابة' },
  { value: 'answered', label: 'تمت الإجابة عليها' },
  { value: 'needs_admin_review', label: 'تحتاج مراجعة إدارية' },
  { value: 'closed', label: 'مغلقة' },
  { value: 'all', label: 'كل الحالات' },
];

// Values match the `date_range` param contract exactly.
export const DATE_RANGE_OPTIONS: FilterOption<InsightsDateRange>[] = [
  { value: 'all_time', label: 'كل الوقت' },
  { value: 'today', label: 'اليوم' },
  { value: 'yesterday', label: 'أمس' },
  { value: 'last_7_days', label: 'آخر 7 أيام' },
  { value: 'last_30_days', label: 'آخر 30 يوماً' },
  { value: 'this_month', label: 'هذا الشهر' },
  { value: 'last_month', label: 'الشهر الماضي' },
  { value: 'custom', label: 'مخصص' },
];

export const DEFAULT_FILTERS: InsightsFilters = {
  status: null,
  specializationId: null,
  expertId: null,
  cohortId: null,
  dateRange: 'last_30_days',
  dateFrom: null,
  dateTo: null,
};
